import { createContext, useContext } from 'react'

import { NotificationProps } from './SnackbarProvider'




export interface SnackbarContextState {
  open: ({ type, title, text, action }: NotificationProps) => void
  close: () => void
}

export const SnackbarContext = createContext<SnackbarContextState>({} as SnackbarContextState)

export function useSnackbar(): SnackbarContextState {
  return useContext(SnackbarContext)
}
